import { initMercadoPago } from "@mercadopago/sdk-react";

export const mpPublicKey = "APP_USR-4720b5df-b8f0-4109-a06b-1b9889b62ad2"; //import.meta.env.VITE_MP_PUBLIC_KEY as string;

if (mpPublicKey) {
  initMercadoPago(mpPublicKey);
}
